// @flow

import memberHeaderStyles from '../../Feed/Styles/MemberHeader.Style';

const integrationsHeaderStyles = {
  ...memberHeaderStyles,
  // Override toolbar to use single-row height instead of double-row
  toolbarSingleRow: (theme) => ({
    ...memberHeaderStyles.toolbar(theme),
    minHeight: theme.layout.customProps.header.height,
    [theme.breakpoints.down('sm')]: {
      minHeight: theme.layout.customProps.header.height
    }
  }),
  // Override appBar to use single-height margin for sibling selector
  appBar: (theme) => ({
    ...memberHeaderStyles.appBar(theme),
    // Override the sibling selector for single-row header
    '& + * + *': {
      marginTop: `calc(${theme.layout.customProps.header.height}px + ${theme.spacing(4)})`, // Single height instead of double
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4)
    }
  })
};

export default integrationsHeaderStyles;